/* import __COLOCATED_TEMPLATE__ from './triggers.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { type MatchCheck } from 'embercom/objects/matching-system/match-check';

interface Args {
  matchCheck: MatchCheck;
}

export default class TriggersComponent extends Component<Args> {
  @tracked openSectionId = 0;

  @action openSection(id: number) {
    this.openSectionId = id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MatchingSystem::MatchChecks::Triggers': typeof TriggersComponent;
  }
}
